console.log('pdp-only-drmvsn');

// tab 박스 토글
function tboxActive(element) {
  var tabBox = document.querySelectorAll(".tab-box");

  if (element.parentElement.className.indexOf("opened") < 0) {
    for (var i = 0; i < tabBox.length; i++) {
      tabBox[i].classList.remove("opened");
    }
    element.parentElement.classList.add("opened");
  } else {
    for (var i = 0; i < tabBox.length; i++) {
      tabBox[i].classList.remove("opened");
    }
  }
}

// 상품 설명 Read more
document.addEventListener('DOMContentLoaded', function() {
  const pdpPrdDetail = document.querySelector('.drmvsn-pdp .product__info-wrapper .product__description');
  const viewBtn = document.querySelector('.drmvsn-pdp .product__info-wrapper .pdp-read-more');
  if(pdpPrdDetail.offsetHeight > 83) {
    pdpPrdDetail.classList.add('more');
  }
});
const pdpReadMore = (el) => {
  document.querySelector('.drmvsn-pdp .product__info-wrapper .product__description').classList.toggle('read-more');
}


// 상품 상세 이미지
const pdpPrdSwiper = new Swiper('.pdp-prd-swiper', {
  direction: 'horizontal',
  slidesPerView: 1,
  scrollbar: {
    el: ".pdp-prd-swiper .swiper-scrollbar",
  },
  breakpoints: {
      990: {
        slidesPerView: 20,
      },
  }
});

// 관련 상품
  const pdpRelSwiper = new Swiper('.drmvsn-related-products', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    slidesOffsetAfter: 32,
    pagination: {
        el: ".drmvsn-related-products .swiper-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: ".drmvsn-related-products .swiper-button-next",
        prevEl: ".drmvsn-related-products .swiper-button-prev",
    },
    scrollbar: {
        el: ".drmvsn-related-products .swiper-scrollbar",
    },
    breakpoints: {
      990: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesOffsetAfter: 40,
      },
    }
  });

//옵션 모바일 셀렉트박스(형태만)

const optionSelect = (el) => {
  // el.parentElement.classList.toggle('select-active');

  // document.querySelectorAll('.drmvsn-pdp .product__info-wrapper .product-form__input .form__label').forEach((label) => {
  //   if(label.parentElement.classList.contains('select-active')) label.parentElement.classList.remove('select-active');
  // });

  // el.parentElement.classList.add('select-active');


    
        if(el.parentElement.classList.contains('select-active')) {
         el.parentElement.classList.remove('select-active');
        } else {
            document.querySelectorAll('.drmvsn-pdp .product__info-wrapper .product-form__input .form__label').forEach((label) => {
              label.parentElement.classList.remove('select-active');
              el.parentElement.classList.add('select-active');
            });
        }


}

const removeSelect = (el) => {
  el.closest('.product-form__input').classList.remove('select-active');
}


// 모달
const shippingModalToggle = (e) => {
  console.log(e)
  document.querySelector('.pdp-shipping-modal').classList.toggle('active')
}

/*이미지 한 개일 때 sticky - relative 적용하기 250403 yeonsu*/
const noHideImg = document.querySelectorAll(".drmvsn-pdp .product__media-list.grid > li:not(.hide-image)");

if(noHideImg.length < 2) {
  document.querySelector('.drmvsn-pdp .product.grid').classList.add('no-sticky');
}